import { Action, createReducer, on } from '@ngrx/store';

import { inputSearchTerm, openPage } from './newsfeed-page.actions';

export const NEWSFEED_PAGE_FEATURE_KEY = 'newsfeedPage';

export interface NewsfeedPageState {
  searchTermFragment: string;
}

export const initialNewsfeedPageState: NewsfeedPageState = { searchTermFragment: '' };

const reducer = createReducer(
  initialNewsfeedPageState,
  on(openPage, () => initialNewsfeedPageState),
  on(inputSearchTerm, (state, { searchTermFragment }) => ({ ...state, searchTermFragment }))
);

export function newsfeedPageReducer(state: NewsfeedPageState | undefined, action: Action) {
  return reducer(state, action);
}
